<template>
  <div
    class="map-template"
    ><div
      ref="googleMap"
      class="google-map"
    ></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template>
  </div>
</template>

<script>
import GoogleMapsApiLoader from 'google-maps-api-loader';

export default {
  props: {
    mapConfig: Object,
    apiKey: String,
  },

  data() {
    return {
      google: null,
      map: null,
    };
  },

  async mounted() {
    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey,
    });
    this.google = googleMapApi;
    this.initializeMap();
  },

  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(
        mapContainer, this.mapConfig,
      );
    },
  },
};
</script>

<style scoped>
  .google-map {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  .map-template {
    width: 100%;
    height: 100%;
  }
</style>
